import { Carousel } from 'antd';
import carousel1 from './img/carousel1.jpg'
import carousel2 from './img/carousel2.jpg'
import carousel3 from './img/carousel3.jpg'
import Nav from './global/Nav'

import FooterSector from './global/FooterSector';
import React, { useEffect, useState } from 'react';
import {Layout } from 'antd';
import SellerCalculatorPage from './calculators/SellerCalculatorPage';



const { Header, Footer, Sider, Content } = Layout;

const headerStyle = {
  textAlign: 'center',
  width: '100%',
  padding: '0'
};

const carouselStyle = {
  width: '100%',
  maxHeight: 200,
  textAlign:'center',
  objectFit: 'cover',     /* Crop the image to cover the div, centered */
  objectPosition: 'center',
  overflow: 'hidden'      /* Ensures any excess is hidden */
}

const contentStyle = {
  minHeight: 120,
  color: '#000',
  backgroundColor: '#fff',
};
const siderStyle = {
  /*textAlign: 'center',
  lineHeight: '120px',
  color: '#fff',*/
  backgroundColor: '#FFFFFF',
};

const layoutStyle = {
  overflow: 'hidden',
  margin: '0',
  width: '100%',
  maxWidth: '100%'
};

function Seller() {

  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    fetch("http://ip-api.com/json/")
      .then((res) => res.json())
      .then((data) => {
        setCountry(data.country);
        setCurrency(getCurrencyCode(data.countryCode));
      })
      .catch((err) => console.error("Error fetching location:", err));
  }, []);


  // Function to map country codes to currency codes
  const getCurrencyCode = (countryCode) => {
    const currencyMap = {
      ZA: "ZAR", // South Africa
      US: "USD", // United States
      GB: "GBP", // United Kingdom
      NG: "NGN", // Nigeria
      KE: "KES", // Kenya
      IN: "INR", // India
      // Add more as needed
    };
    return currencyMap[countryCode] || "USD"; // Default to USD if not found
  };

  return (
    <Layout style={layoutStyle}>
      <Header style = {headerStyle}>
         <Nav/>         
      </Header>

      <Layout style={{backgroundColor:"white"}}>
      
      
         <Carousel autoplay autoplaySpeed={2500} style={{"padding":"0"}} >
          <div>
            <img style={carouselStyle} src={carousel1}/>  
          </div>
          <div>
            <img style={carouselStyle} src={carousel2}/>  
          </div>
          <div>
            <img style={carouselStyle} src={carousel3}/>  
          </div>
         </Carousel>
    
         {/*<h2 style={{color: '#1677FF', textAlign:'center'}}>Your Real Estate Insight Hub!</h2>

      */}

        <Layout>
        
      
        <Content style={contentStyle}>
       
         
         {/* <h2>Welcome {country} - {currency}</h2>*/}

            <SellerCalculatorPage/>
        
        </Content>
        <Sider width="15%" style={siderStyle}>
         
        </Sider>
        </Layout>

      </Layout>
      <FooterSector/>
    </Layout>
  );
}

export default Seller;
